export default __webpack_public_path__ + "static/media/9.6e7f4ea7.jpg";